import { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import dynamic from 'next/dynamic';
import PageHeader from 'UI/components/PageHeader';
import AiEngineeringPodBadge from 'UI/components/AiEngineeringPodBadge';
import MetaTags from 'components/Common/MetaTags';
import { getDocumentFields, rootUrl } from 'utils/helper';
import { PAGES, PAGES_WITH_DARK_BREADCRUMBS } from 'utils/constants';
import { useFetchPageQuery } from 'redux/apis/page';
import { getBreadcrumbs } from 'utils/breadcrumbs';
import SectionSelector from 'UI/components/SectionSelector';
import FullScreenEstimation from 'components/Common/FullScreenEstimation';
import styles from './styles.module.scss';

const Services = ({
  introSection,
  metaData,
  type,
  contentModules: ssrContentModules,
}) => {
  const { data = {} } = useFetchPageQuery(type, { skip: Boolean(ssrContentModules) });
  const contentModules = ssrContentModules ?? data.contentModules;

  const [isFullscreenEstimation, setIsFullscreenEstimation] = useState(false);

  const breadcrumbs = getBreadcrumbs(type);
  const pageMetadata = { ...metaData, url: `${rootUrl}/${type}` };

  const breadcrumbsTheme = PAGES_WITH_DARK_BREADCRUMBS.includes(type) ? 'dark' : null;
  const openFullscreenEstimation = () => setIsFullscreenEstimation(true);
  const closeFullscreenEstimation = () => setIsFullscreenEstimation(false);

  if (!contentModules) {
    return null;
  }

  return (
    <>
      <MetaTags
        page={type}
        pageMetadata={pageMetadata}
        breadcrumbs={breadcrumbs}
      />
      <div className={cn(styles.container, styles[type])}>
        <PageHeader
          breadcrumbs={breadcrumbs}
          titleStyles={styles.pageTitle}
          breadcrumbsStyles={styles.breadcrumbs}
          breadcrumbsTheme={breadcrumbsTheme}
        />
        {contentModules?.map((module, i) => {
          const { type: sectionType, view, slug } = getDocumentFields(module);

          return (
            <SectionSelector
              key={`section/${i}`}
              data={module}
              type={type}
              introSection={introSection}
              handleOnCTAClick={openFullscreenEstimation}
            />
          );
        })}
        <AiEngineeringPodBadge />
      </div>
      <FullScreenEstimation
        isFullscreenEstimation={isFullscreenEstimation}
        closeFullscreenEstimation={closeFullscreenEstimation}
      />
    </>
  );
};

Services.propTypes = {
  type: PropTypes.string.isRequired,
};

export default Services;
